/// <reference types="vite/client" />
import { Parties } from 'merchant-api/types';
import { unifiedApiClient } from 'merchant-api/unified';
import { queryOptions, useQuery, UseQueryResult } from '@tanstack/react-query';

export interface UseParties {
  isLoadingParties: boolean;
  partiesData: Parties | undefined;
  partyId: string | undefined;
  isErrorParties: Error | null;
  isApplicant: boolean;
  isRenewal: boolean;
  hasLOC: string | undefined;
  hasTL: string | undefined;
  personId: string | undefined;
  businessId: string | undefined;
  termLoans: string[];
  query: UseQueryResult<Parties>;
  isMultiOwner: boolean | undefined;
}

export function useParties(options: { enabled?: boolean } = {}): UseParties {
  const query = useQuery({ ...getPartiesOpts, enabled: options.enabled ?? true });
  const { data, error, isLoading } = query;
  return {
    isApplicant: data?.parties?.some((e: any) => e.type === 'APPLICANT') ?? false,
    isRenewal: data?.parties?.some((e: any) => e.type === 'CUSTOMER') ?? false,
    partiesData: data,
    partyId: data?.parties?.[0]?.id || undefined,
    personId: data?.parties?.[0]?.people?.[0]?.id || undefined,
    businessId: data?.parties?.[0]?.businesses?.[0]?.id || undefined,
    isLoadingParties: isLoading,
    isErrorParties: error,
    hasLOC: data?.parties?.flatMap((p) => p.loans?.filter((l) => l.loanType === 'LINE_OF_CREDIT').map((l) => l.id))[0] || undefined,
    hasTL: data?.parties?.flatMap((p) => p.loans?.filter((l) => l.loanType === 'FIXED_TERM').map((l) => l.id))[0] || undefined,
    isMultiOwner: data?.parties?.[0]?.people?.length ? data?.parties?.[0]?.people?.length > 1 : undefined,
    termLoans: data?.parties?.flatMap((p) => p.loans?.filter((l) => l.loanType === 'FIXED_TERM').map((l) => l.id)) || [],
    query,
  };
}

export default useParties;

const getParties = async () => {
  const get = unifiedApiClient.GET as any;
  const { data } = await get('/client/parties');
  return data as Parties;
};

export const getPartiesOpts = queryOptions<Parties>({
  queryKey: ['parties'],
  queryFn: getParties,
  retry: 0,
  refetchOnWindowFocus: false,
});
